export default __webpack_public_path__ + "static/media/Flexa.b57fe6de.png";